class AdventCalendarAccountModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose.bind(this))
    })

    this.listeners.add(document, 'click', this.handleTrigger.bind(this))
  }

  handleClose () {
    this.setAttribute('aria-hidden', true)
  }

  handleTrigger (event) {
    const registerEl = event.target.closest(
      '[data-advent-calendar-account-modal-external-el="register"]',
    )

    const loginEl = event.target.closest(
      '[data-advent-calendar-account-modal-external-el="login"]',
    )

    if (!registerEl && !loginEl) return

    this.setAttribute('aria-hidden', false)

    if (registerEl) {
      this.els.register.element.setAttribute('aria-hidden', false)
      this.els.login.element.setAttribute('aria-hidden', true)
    }

    if (loginEl) {
      this.els.register.element.setAttribute('aria-hidden', true)
      this.els.login.element.setAttribute('aria-hidden', false)
    }
  }
}

if (!customElements.get('advent-calendar-account-modal')) {
  customElements.define(
    'advent-calendar-account-modal',
    AdventCalendarAccountModal,
  )
}
